/**
 * 压缩图片
 * @param blob 图片Blob
 * @param maxSize 最大大小（字节）
 * @returns 压缩后的图片Blob
 */
export const compressImage = async (blob: Blob, maxSize: number): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const img: HTMLImageElement = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        reject(new Error('Failed to get canvas context'));
        return;
      }

      let quality = 0.9;
      let width = img.width;
      let height = img.height;

      const tryCompress = () => {
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob((compressedBlob) => {
          if (!compressedBlob) {
            reject(new Error('Failed to compress image'));
            return;
          }

          if (compressedBlob.size <= maxSize || quality <= 0.1) {
            resolve(compressedBlob);
          } else {
            quality -= 0.1;
            if (quality < 0.5) {
              width = Math.floor(width * 0.8);
              height = Math.floor(height * 0.8);
            }
            tryCompress();
          }
        }, 'image/png', quality);
      };

      tryCompress();
    };

    img.onerror = () => reject(new Error('Failed to load image'));
    img.src = URL.createObjectURL(blob);
  });
};